import { TrendingUp, X } from 'lucide-react';

const WEEKLY_DATA = {
  lumina: {
    icon: TrendingUp,
    color: '#6b5ce7',
    text: 'Last week: 42 notes generated, 3.2 hours of documentation time saved, 0 after-hours notes.',
  },
  echo: {
    icon: TrendingUp,
    color: '#3b82f6',
    text: 'Last week: 87 calls handled by AI, 6 no-shows prevented, 4 cancellation slots filled automatically.',
  },
  revq: {
    icon: TrendingUp,
    color: '#10b981',
    text: 'Last week: 31 claims processed, 4 denials prevented, $1,840 in estimated revenue protected.',
  },
};

const WeeklySummaryCard = ({ app, onDismiss }) => {
  const data = WEEKLY_DATA[app];
  if (!data) return null;

  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: 10,
        padding: '14px 16px',
        border: '0.5px solid #e8e8e8',
        marginBottom: 16,
      }}
      data-testid={`weekly-summary-${app}`}
    >
      <div className="flex items-start gap-3">
        <div
          className="flex items-center justify-center flex-shrink-0"
          style={{ width: 28, height: 28, borderRadius: 8, background: `${data.color}12` }}
        >
          <data.icon style={{ width: 14, height: 14, color: data.color }} />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <p style={{ fontSize: 11, fontWeight: 600, color: '#111111', margin: 0, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
              Weekly AI Summary
            </p>
            {onDismiss && (
              <button
                onClick={onDismiss}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2 }}
                data-testid="weekly-summary-dismiss"
              >
                <X style={{ width: 12, height: 12, color: '#aaaaaa' }} />
              </button>
            )}
          </div>
          <p style={{ fontSize: 12, color: '#555555', margin: '4px 0 0', lineHeight: 1.6, fontWeight: 400 }}>
            {data.text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default WeeklySummaryCard;
